import React from "react";

import { AccreditationCard, CredentialWrapper, HealthAndSafetyContainer, HealthAndSafetyCreditations, HealthAndSafetyKicker, HealthAndSafetyPageLink, HealthAndSafetyText, HealthAndSafetyTitle, HealthAndSafetyWrapper } from "./health_and_safety.styles";

const credentials = [
  { src: "https://www.safetypassports.co.uk/wp-content/uploads/2013/02/cropped-SPA-Banner-Logo.png", alt: "Safety Passports Accreditation" },
  { src: "https://cdn-res.keymedia.com/cms/images/us/069/0343_638477691031814524.png", alt: "ISO Accreditation" },
  { src: "https://i.imgur.com/L7Kjt4T.png", alt: "SSIP Accreditation" },
];

const HealthAndSafety = () => {
  return (
    <HealthAndSafetyContainer>
      <HealthAndSafetyWrapper>
        <HealthAndSafetyKicker>Our commitments</HealthAndSafetyKicker>
        <HealthAndSafetyTitle>Health and Safety Accreditations</HealthAndSafetyTitle>
        <HealthAndSafetyText>For anyone working in the construction industry, health and safety is a top priority. Cutting corners is never an option, and a strong commitment to safety must be embedded in the culture and embraced by every team member.</HealthAndSafetyText>
        <CredentialWrapper>
          {credentials.map((c) => (
            <AccreditationCard key={c.alt}>
              <HealthAndSafetyCreditations src={c.src} alt={c.alt} />
            </AccreditationCard>
          ))}
        </CredentialWrapper>
        <HealthAndSafetyPageLink href="/health-safety">Learn more about our approach</HealthAndSafetyPageLink>
      </HealthAndSafetyWrapper>
    </HealthAndSafetyContainer>
  );
};

export default HealthAndSafety;
